export const normalizeCompanyPaymentTerm = paymentTerm => {
    const normalized = String(paymentTerm || '').trim().toLowerCase();

    if (!normalized || ['n/a', 'n_a', 'na', 'ondemand', 'prepay', 'single'].includes(normalized)) {
        return 'single';
    }

    if (normalized === 'monthly' || normalized === '30') {
        return 'net_30';
    }

    if (normalized === '14') {
        return 'net_14';
    }

    if (normalized === '60') {
        return 'net_60';
    }

    if (normalized === '120') {
        return 'net_120';
    }

    return normalized;
};

export const getNetDueDays = paymentTerm => {
    const normalized = normalizeCompanyPaymentTerm(paymentTerm);

    if (normalized === 'net_14') {
        return 14;
    }

    if (normalized === 'net_30') {
        return 30;
    }

    if (normalized === 'net_60') {
        return 60;
    }

    if (normalized === 'net_120') {
        return 120;
    }

    return 0;
};

export const getCompanyPaymentTermLabel = paymentTerm => {
    const normalized = normalizeCompanyPaymentTerm(paymentTerm);

    if (normalized === 'daily') {
        return 'Daily';
    }

    if (normalized === 'weekly') {
        return 'Weekly';
    }

    if (normalized === 'net_14') {
        return 'Net 14';
    }

    if (normalized === 'net_30') {
        return 'Net 30';
    }

    if (normalized === 'net_60') {
        return 'Net 60';
    }

    if (normalized === 'net_120') {
        return 'Net 120';
    }

    return 'Prepay';
};

export const getCompanyPaymentTermPolicy = ({ paymentTerm, isQuoteOnly = false, isAdminOnBehalf = false } = {}) => {
    const normalizedTerm = normalizeCompanyPaymentTerm(paymentTerm);
    const isPrepay = normalizedTerm === 'single';
    const isDaily = normalizedTerm === 'daily';
    const isWeekly = normalizedTerm === 'weekly';
    const isGrouped = isDaily || isWeekly;
    const isNetTerms = ['net_14', 'net_30', 'net_60', 'net_120'].includes(normalizedTerm);

    let collectionType = 'immediate';
    if (isDaily) {
        collectionType = 'end_of_day';
    } else if (isWeekly) {
        collectionType = 'end_of_week';
    } else if (isNetTerms) {
        collectionType = 'net_terms';
    }

    let description = 'Payment is due at checkout.';
    if (isQuoteOnly) {
        description = 'Final price requires quote approval. Payment will follow the company payment terms after quote approval.';
    } else if (isDaily) {
        description = 'Completed orders are grouped and charged automatically at the end of the day. A saved card is required.';
    } else if (isWeekly) {
        description = 'Completed orders are grouped and charged automatically at the end of the week. A saved card is required.';
    } else if (isNetTerms) {
        description = `Invoices are sent after completion and become due ${getNetDueDays(normalizedTerm)} days later. Customers can either use company terms or pay now with a card.`;
    }

    return {
        normalizedTerm,
        label: getCompanyPaymentTermLabel(normalizedTerm),
        description,
        collectionType,
        dueDays: getNetDueDays(normalizedTerm),
        isQuoteOnly,
        isAdminOnBehalf,
        isPrepay,
        isGrouped,
        isNetTerms,
        paymentMethodRequired: !isQuoteOnly && (isPrepay || isGrouped),
        requiresSavedCardOnFile: !isQuoteOnly && (isPrepay || isGrouped),
        allowsCompanyTermsSelection: !isQuoteOnly && !isPrepay,
        allowsImmediateCardSelection: !isQuoteOnly && (isPrepay || isNetTerms),
        allowsPendingWithoutCard: Boolean(isAdminOnBehalf && !isQuoteOnly && (isPrepay || isGrouped)),
        defaultSelectedPaymentMode: isPrepay ? 'card' : 'company_terms',
    };
};
